import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import {
    Book,
    Search,
    LogIn,
    LayoutDashboard,
    CheckSquare,
    Clock,
    FolderKanban,
    Users,
    Calendar,
    Palmtree,
    MessageCircle,
    Trophy,
    Ticket,
    Key,
    StickyNote,
    Settings,
    Globe,
    Shield,
    ChevronRight,
    ChevronDown,
    Sparkles,
    Bot,
    Mic,
    FileText
} from 'lucide-react';

const HandbuchPage = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [expandedSections, setExpandedSections] = useState({});
    
    // Logo URL
    const logoUrl = 'https://customer-assets.emergentagent.com/job_28db0f0f-fdc7-48d3-bd92-c5288f5837fb/artifacts/lnc4gc1p_nyza%20logo.png';

    const toggleSection = (id) => {
        setExpandedSections(prev => ({ ...prev, [id]: !prev[id] }));
    };

    const chapters = [
        {
            id: 'ai-assistant',
            icon: Bot,
            title: 'KI-Assistent',
            color: '#8B5CF6',
            content: [
                {
                    title: '🤖 Was ist der KI-Assistent?',
                    text: 'Dein intelligenter Arbeitsassistent wie Siri oder Alexa - aber für AgencyOS! Sprich oder tippe einfach was du brauchst, und der Assistent erledigt es für dich.'
                },
                {
                    title: '🎤 Spracheingabe',
                    text: 'Mikrofon-Button gedrückt halten → Sprechen → Loslassen. Deine Sprache wird automatisch erkannt und in Text umgewandelt.'
                },
                {
                    title: '📝 Tasks erstellen',
                    text: '• "Erstelle Task Website Banner für Lisa"\n• "Neue Aufgabe Social Media Post bis Freitag"\n• "Task Report für Kunde Müller mit hoher Priorität"\n• "Erstelle wöchentlichen Task Team-Meeting"\n• "Task Logo-Design mit Account Manager Max"'
                },
                {
                    title: '🔄 Wiederkehrende Tasks',
                    text: '• "Erstelle täglichen Task E-Mails checken"\n• "Wöchentlicher Task Reporting jeden Montag"\n• "Monatlicher Task Rechnung an Kunde X"\n• Muster: täglich, wöchentlich, alle 2 Wochen, monatlich\n\n→ Wenn der Task erledigt wird, erstellt sich automatisch der nächste!'
                },
                {
                    title: '✏️ Tasks bearbeiten',
                    text: '• "Setze Task Banner auf Priorität hoch"\n• "Verschiebe Task Website auf nächste Woche"\n• "Weise Task Logo Max zu"\n• "Markiere Task Report als erledigt"'
                },
                {
                    title: '🔍 Tasks suchen',
                    text: '• "Zeig meine offenen Tasks"\n• "Welche Aufgaben habe ich heute?"\n• "Überfällige Tasks"\n• "Tasks von Projekt Website"\n• "Finde Task mit Logo"'
                },
                {
                    title: '📅 Kalender-Events',
                    text: '• "Meeting morgen um 14 Uhr"\n• "Kundengespräch mit Müller am Freitag 10 Uhr"\n• "Blockiere Freitag Nachmittag"\n• "Was steht heute im Kalender?"\n• "Termine diese Woche"'
                },
                {
                    title: '📁 Projekte',
                    text: '• "Erstelle Projekt für Kunde Müller"\n• "Neues Projekt Website Relaunch mit 3 Tasks"\n• "Zeig alle aktiven Projekte"\n• "Projekte von Kunde Schmidt"'
                },
                {
                    title: '⏱️ Zeiterfassung',
                    text: '• "Starte Zeit für Website Design"\n• "Stopp die Zeit"\n• "Buche 2 Stunden auf Projekt XY"\n• "Wie viele Stunden diese Woche?"\n• "Meine Stunden letzten Monat"'
                },
                {
                    title: '🌴 Urlaub',
                    text: '• "Beantrage Urlaub vom 12. bis 20. Juli"\n• "2 Tage Urlaub nächste Woche"\n• "Wer ist im Urlaub?"\n• "Wie viele Urlaubstage habe ich noch?"'
                },
                {
                    title: '📊 Zusammenfassungen',
                    text: '• "Was steht heute an?"\n• "Was ist am wichtigsten?"\n• "Deadlines diese Woche"\n• "Wie viele Punkte habe ich?"'
                },
                {
                    title: '👥 Team-Abfragen',
                    text: '• "Wer arbeitet an Projekt XY?"\n• "Wer ist nächste Woche im Urlaub?"\n• "Wer ist heute im Büro?"\n• "Zeig mir die Workload von Max"\n• "Wie ausgelastet ist Lisa?"'
                },
                {
                    title: '📊 Workload-Übersicht',
                    text: 'Frage nach der Auslastung eines Teammitglieds:\n• Offene, laufende und überfällige Tasks\n• Diese Woche gebuchte Stunden\n• Aktive Projekte\n• Auslastungs-Level: 🟢 Normal / 🟡 Mittel / 🔴 Hoch'
                },
                {
                    title: '🎭 Social Faces suchen (NEU)',
                    text: '• "Suche blonde Frauen ohne Tattoos"\n• "Finde Männer mit braunen Haaren aus Wien"\n• "Zeig mir vegetarische Models mit Piercing"\n• "Social Faces die deutsch sprechen"\n• "Frauen mit Brille und blauen Haaren"\n\nDer Assistent durchsucht die Social Faces Datenbank und zeigt dir:\n→ Profilbild, Name, Kontaktdaten\n→ Klick auf ein Ergebnis öffnet das vollständige Profil\n→ Direkt anrufen oder E-Mail senden'
                },
                {
                    title: '🏢 Projekte nach Kunde',
                    text: '• "Zeig Projekte von Kunde Müller"\n• "Welche Projekte hat Firma XY?"\n• "Aktive Projekte für BMW"\n\nFiltert automatisch alle Projekte für den genannten Kunden.'
                },
                {
                    title: '💡 Tipps',
                    text: '• Sprich natürlich - der Assistent versteht dich!\n• Datumsbegriffe: "morgen", "nächste Woche", "Freitag", "in 3 Tagen"\n• Prioritäten: "wichtig", "dringend", "hoch" = Hohe Priorität\n• Selbstzuweisung: "mir", "mir selbst", "für mich"'
                }
            ]
        },
        {
            id: 'login',
            icon: LogIn,
            title: 'Login & Authentifizierung',
            color: '#007AFF',
            content: [
                {
                    title: '🔐 Anmeldung',
                    text: 'Gib deinen Benutzernamen und Passwort ein. Die Sitzung bleibt 7 Tage aktiv.'
                },
                {
                    title: '🔑 Passwort ändern',
                    text: 'Profil-Menü (oben rechts) → Passwort ändern → Altes und neues Passwort eingeben.'
                },
                {
                    title: '👥 Benutzer-Rollen',
                    text: '• Chef: Alle Rechte, System-Einstellungen\n• Account Manager: Kunden/Projekte verwalten\n• Buchhaltung: Zeit-Einträge, begrenzte Rechte\n• Mitarbeiter: Tasks bearbeiten, Zeit erfassen'
                }
            ]
        },
        {
            id: 'dashboard',
            icon: LayoutDashboard,
            title: 'Dashboard',
            color: '#FF9500',
            content: [
                {
                    title: '⏱️ Zeiterfassung-Widget',
                    text: 'Start/Stop Timer mit einem Klick. Zeigt aktuelle Laufzeit und heute gearbeitete Stunden.'
                },
                {
                    title: '📊 Wochenübersicht',
                    text: 'Wochenstunden vs. Soll-Stunden mit Progress-Bar. Plus Resturlaub und offene Tasks.'
                },
                {
                    title: '🌤️ Wetter-Widget',
                    text: 'Aktuelles Wetter am eingestellten Standort. Konfigurierbar unter Profil → Wetter-Standort.'
                },
                {
                    title: '🏆 Challenge-Punkte',
                    text: 'Dein aktueller Punktestand. Klick führt zur Challenges-Seite.'
                },
                {
                    title: '📅 Kommende Termine',
                    text: 'Die nächsten 3 Kalender-Termine mit Farbkodierung, Zeit und Ort.'
                },
                {
                    title: '📋 Meine Tasks',
                    text: 'Die nächsten 4 offenen Tasks mit Status-Emoji und Deadline.'
                }
            ]
        },
        {
            id: 'tasks',
            icon: CheckSquare,
            title: 'Task-Management',
            color: '#34C759',
            content: [
                {
                    title: '📋 Kanban-Board',
                    text: 'Spalten: Offen, In Bearbeitung, Review, Erledigt. Drag & Drop zwischen Spalten.'
                },
                {
                    title: '➕ Task erstellen',
                    text: 'Titel, Beschreibung, Status, Priorität (Hoch/Mittel/Niedrig), Deadline, Zuweisungen, Projekt, Account Manager.'
                },
                {
                    title: '🔄 Wiederkehrende Tasks',
                    text: 'Muster wählen: Täglich, Wöchentlich, Alle 2 Wochen, Monatlich.\n\n→ Funktionsweise:\n1. Task mit Wiederholung erstellen\n2. Task als "Erledigt" markieren\n3. System erstellt automatisch neuen Task mit nächstem Datum!\n\nBeispiel: Wöchentlicher Report (Deadline 20.03.) → Erledigt → Neuer Task erscheint mit Deadline 27.03.\n\nDer neue Task behält alle Infos: Titel, Beschreibung, Priorität, Zuweisung, Account Manager.'
                },
                {
                    title: '👤 Account Manager',
                    text: 'Jedem Task kann ein Account Manager zugewiesen werden. Dieser wird bei Änderungen benachrichtigt und behält den Überblick über Kundenaufgaben.'
                },
                {
                    title: '💬 Kommentare & Dateien',
                    text: 'Team-Kommunikation zum Task. Dateien per Drag & Drop hochladen.'
                },
                {
                    title: '🎨 Custom Status (Admin)',
                    text: 'Eigene Status erstellen mit Farbe und Emoji. Reihenfolge per Drag & Drop ändern.'
                }
            ]
        },
        {
            id: 'time',
            icon: Clock,
            title: 'Zeiterfassung',
            color: '#5856D6',
            content: [
                {
                    title: '▶️ Live-Timer',
                    text: 'Play-Button drücken → Timer läuft → Stop-Button → Kunde/Task/Aktivität wählen → Speichern.'
                },
                {
                    title: '⏸️ Stop-Modal Optionen',
                    text: '• Pause: Pausenzeit erfassen\n• Allgemein: Zeit ohne Kundenzuordnung\n• Auf Kunde buchen: Kunde + Task + Aktivitätstyp'
                },
                {
                    title: '🎯 Aktivitätstypen',
                    text: 'Grafik, Videoschnitt, Reporting, Storyboard, Entwicklung, Meeting, Planung, Support.'
                },
                {
                    title: '📝 Manuelle Einträge',
                    text: 'Zeiten → + Manueller Eintrag → Startzeit, Endzeit, Kunde, Beschreibung.'
                },
                {
                    title: '📥 Export-Funktion (NEU)',
                    text: '• Export-Button → Zeitraum auswählen (Start/Enddatum)\n• Download als CSV-Datei\n• Enthält: Datum, Kunde, Projekt, Task, Beschreibung, Dauer, Mitarbeiter\n• Öffnet sich in Excel und Google Sheets\n• Dateiname: zeiteintraege_YYYY-MM-DD_bis_YYYY-MM-DD.csv'
                },
                {
                    title: '🔒 Sperrfristen',
                    text: 'Einträge älter als 2 Monate sind gesperrt. Nur Chef kann diese bearbeiten.'
                }
            ]
        },
        {
            id: 'projects',
            icon: FolderKanban,
            title: 'Projekte',
            color: '#FF2D55',
            content: [
                {
                    title: '📁 Projekt erstellen',
                    text: 'Name, Kunde, Beschreibung, Deadline, Team, CI-Farben, Logo.'
                },
                {
                    title: '🎯 Meilensteine',
                    text: 'Titel, Beschreibung, Deadline. Status: Offen / Erledigt. Progress wird automatisch berechnet.'
                },
                {
                    title: '📎 Dateien & Links',
                    text: 'Dateien hochladen (Cloudflare R2). Links zu Google Drive, Figma, etc.'
                },
                {
                    title: '⏱️ Zeit-Statistik',
                    text: 'Gesamt gebuchte Stunden und Aufschlüsselung nach Teammitglied.'
                }
            ]
        },
        {
            id: 'customers',
            icon: Users,
            title: 'Kunden (CRM)',
            color: '#00C7BE',
            content: [
                {
                    title: '👤 Kunde erstellen',
                    text: 'Name, Website, E-Mail, Telefon, Adresse, Paket-Name, Paket-Inhalt.'
                },
                {
                    title: '🎨 Corporate Identity',
                    text: 'CI-Farben (mehrere möglich), Logos hochladen.'
                },
                {
                    title: '📱 Social Media',
                    text: 'LinkedIn, Instagram, Facebook, YouTube, TikTok, Twitter.'
                },
                {
                    title: '📝 Interne Notizen',
                    text: 'Nur für Team sichtbare Notizen zum Kunden.'
                },
                {
                    title: '🌐 Öffentliche Seite',
                    text: 'Globe-Icon → Public Page aktivieren. Siehe Kapitel "Öffentliche Portale".'
                }
            ]
        },
        {
            id: 'calendar',
            icon: Calendar,
            title: 'Kalender',
            color: '#FF3B30',
            content: [
                {
                    title: '📅 Ansichten',
                    text: '• Wochenansicht: 7 Tage horizontal, Drag & Drop\n• Monatsansicht: Vollständiger Monat\n• Tagesansicht: 24-Stunden-Timeline'
                },
                {
                    title: '➕ Event erstellen',
                    text: 'Titel, Ganztägig, Start/Ende, Ort, Beschreibung, Wiederholen, Erinnerung, Farbe, Teilnehmer, Zielkalender.'
                },
                {
                    title: '⚡ Event-Vorlagen',
                    text: 'Daily Standup (15 Min), Kundencall (60 Min), Team Meeting (60 Min), Code Review (30 Min), Sprint Planning (120 Min), Retrospektive (60 Min).'
                },
                {
                    title: '🔔 Erinnerungen',
                    text: 'Keine, 5 Min, 15 Min, 30 Min, 1 Stunde, 1 Tag vorher.'
                },
                {
                    title: '👥 Verfügbarkeits-Ansicht',
                    text: 'Teilnehmer auswählen → Rot = Besetzt, Grün = Frei. "Alle frei"-Zeile zeigt gemeinsame Slots.'
                },
                {
                    title: '🔄 Mehrere Kalender',
                    text: '• Verbinde mehrere iCloud-Kalender gleichzeitig\n• Jeder Kalender kann eine eigene Farbe bekommen\n• Beim Event erstellen: Zielkalender auswählen\n• Urlaubs-Kalender festlegen: Genehmigte Urlaube werden automatisch dort eingetragen'
                },
                {
                    title: '☁️ iCloud Kalender verbinden',
                    text: '1. Einstellungen → Kalender → iCloud wählen\n2. Apple-ID E-Mail eingeben\n3. App-spezifisches Passwort erstellen:\n   → appleid.apple.com → Anmelden → App-spezifische Passwörter\n   → Passwort generieren (Name z.B. "AgencyOS")\n   → Das Passwort wird MIT BINDESTRICHEN angezeigt (z.B. xxxx-xxxx-xxxx-xxxx)\n   → WICHTIG: Passwort genau so MIT BINDESTRICHEN eingeben!\n4. "Kalender laden" klicken\n5. Gewünschte Kalender auswählen\n6. Fertig! Events werden automatisch synchronisiert'
                },
                {
                    title: '🔗 Google Calendar verbinden',
                    text: '1. Einstellungen → Kalender → Google wählen\n2. "Mit Google verbinden" klicken\n3. Google-Konto auswählen und Zugriff erlauben\n4. Fertig!'
                }
            ]
        },
        {
            id: 'forms',
            icon: FileText,
            title: 'Formulare',
            color: '#EF4444',
            content: [
                {
                    title: 'Was sind Formulare?',
                    text: 'Digitale Erfassung verschiedener Formulare im Wizard-Format. QR-Codes für schnellen mobilen Zugriff.'
                },
                {
                    title: 'Shooting-Dokumentation',
                    text: 'Dokumentiere Content-Produktionen:\n1. Datum des Shootings\n2. Uhrzeit (Von - Bis)\n3. Team vor Ort (Name, Position)\n4. Social Faces mit Check-In/Check-Out Zeiten\n5. Notizen & Anmerkungen\n6. Zusammenfassung pruefen & absenden'
                },
                {
                    title: 'Shooting-Zusage',
                    text: 'Für Kunden: Shooting-Teilnahme bestätigen.\n• Persönliche Daten\n• Shooting-Details\n• Digitale Unterschrift\n\nÖffentlicher Link: /shooting-zusage\nQR-Code für schnellen Zugriff.'
                },
                {
                    title: 'Einverständniserklärung',
                    text: 'Für Firmen-Mitarbeiter bei Shootings:\n• Persönliche Daten\n• Firmendaten\n• Kontaktdaten\n• Digitale Unterschrift\n\nÖffentlicher Link: /einverstaendnis\nQR-Code für schnellen Zugriff.'
                },
                {
                    title: 'Client Intake Form',
                    text: '20-Schritte Formular für Neukunden-Onboarding:\n\n• Unternehmensdaten & Branche\n• Ansprechpartner & Kontakt\n• Social Media Accounts\n• Zielgruppe & Positionierung\n• Content-Wünsche & Formate\n• Budget & Timeline\n• CI-Dateien Upload\n• Rechtliche Infos\n\nÖffentlicher Link: /client-intake\nQR-Code für Kunden zum selbst ausfüllen.'
                },
                {
                    title: 'Spesenabrechnung',
                    text: 'Ausgaben einreichen:\n1. Datum der Ausgabe\n2. Kategorie (Fahrtkosten, Verpflegung, Unterkunft, Equipment, Sonstiges)\n3. Betrag in Euro\n4. Beleg hochladen (Pflicht - Foto oder PDF)\n5. Kunde zuordnen (optional)\n6. Beschreibung\n7. Zusammenfassung pruefen & absenden'
                },
                {
                    title: 'Status-Workflow (Spesen)',
                    text: 'Eingereicht: Deine Abrechnung wartet auf Pruefung\nGenehmigt: Ein Admin hat die Spesen freigegeben\nAbgelehnt: Zurueckgewiesen (mit Kommentar)\n\nDu erhaeltst Benachrichtigungen bei Statusaenderungen.'
                },
                {
                    title: 'QR-Codes & PDF-Export',
                    text: 'Jedes Formular hat einen QR-Code für mobilen Zugriff.\nAdmin kann QR-Code anzeigen/kopieren.\n\nJede Einreichung als PDF herunterladen - inkl. Unterschriften und Belege.'
                }
            ]
        },
        {
            icon: Palmtree,
            title: 'Urlaub',
            color: '#30D158',
            content: [
                {
                    title: '📝 Urlaub beantragen',
                    text: 'Startdatum, Enddatum, Grund (optional), Vertretung, Notizen.'
                },
                {
                    title: '✅ Genehmigungsprozess',
                    text: '1. Mitarbeiter stellt Antrag\n2. Chef erhält Benachrichtigung\n3. Chef genehmigt/lehnt ab\n4. Urlaubstage werden vom Kontingent abgezogen'
                },
                {
                    title: '📊 Team-Kalender',
                    text: 'Übersicht wer wann im Urlaub ist. Überschneidungen erkennen.'
                }
            ]
        },
        {
            id: 'chat',
            icon: MessageCircle,
            title: 'Chat-System',
            color: '#007AFF',
            content: [
                {
                    title: '💬 Chat-Typen',
                    text: '• Team-Chat: Für alle, immer oben angepinnt\n• Private Chats: 1:1 Nachrichten\n• Gruppen-Chats: Mehrere Personen'
                },
                {
                    title: '📎 Nachrichten-Funktionen',
                    text: 'Text, Dateien (Drag & Drop), Sprachnachrichten (Mikrofon gedrückt halten), Reaktionen (Emojis).'
                },
                {
                    title: '📞 Video-Calls',
                    text: 'Kamera-Icon → WebRTC-basiert. Kamera/Mikrofon ein/aus, Bildschirm teilen.'
                },
                {
                    title: '🔔 Status-Anzeigen',
                    text: 'Online (grün), Offline (grau), Tipp-Indikator, Lesebestätigungen (blaue Häkchen).'
                }
            ]
        },
        {
            id: 'challenges',
            icon: Trophy,
            title: 'Challenges & Gamification',
            color: '#FFD60A',
            content: [
                {
                    title: '⭐ Punkte verdienen',
                    text: 'Task erledigt: +5 Punkte\nProjekt abgeschlossen: +10 Punkte\nTägliches Einloggen: +1 Punkt'
                },
                {
                    title: '🏆 Achievements (55+)',
                    text: '• Task-Maschine: 50 Tasks abgeschlossen\n• Zeit-Profi: 100 Stunden getrackt\n• Deadline-Held: 20 Tasks vor Deadline'
                },
                {
                    title: '🎖️ Level-System',
                    text: 'Level basiert auf Gesamtpunkten. Badges für Level 5, 10, 25, 50.'
                },
                {
                    title: '🎁 Belohnungen (Admin)',
                    text: 'Belohnungen erstellen (Name, Punkte, Emoji). Mitarbeiter können einlösen.'
                }
            ]
        },
        {
            id: 'benefits',
            icon: Ticket,
            title: 'Vorteilspass',
            color: '#AF52DE',
            content: [
                {
                    title: '🎫 Kategorien',
                    text: 'Food & Drinks, Fitness & Sport, Technik, Fashion, Beauty & Wellness, Entertainment, Reisen, Sonstiges.'
                },
                {
                    title: '💎 VIP Vorzeige-Popup',
                    text: 'Klick auf Benefit-Karte → Großer Rabatt, "AKTIV"-Badge, Mitarbeiter-Info, Live-Zeitstempel, Standort & Kategorie als Infopills. Beim Partner vorzeigen.'
                },
                {
                    title: '📱 QR-Code System (NEU)',
                    text: 'Für Benefits mit Einlöse-Verifizierung:\n\n1. Admin aktiviert "QR-Scan erforderlich" beim Benefit\n2. Admin kann Einlöse-Limit pro Mitarbeiter festlegen\n3. Partner erhält QR-Code zum Ausdrucken\n\nBeim Einlösen:\n→ Mitarbeiter öffnet Benefit und tippt "QR scannen"\n→ Handy-Kamera scannt den QR-Code\n→ Einlösung wird automatisch erfasst\n→ Mitarbeiter und Partner sehen Bestätigung'
                },
                {
                    title: '📲 So funktioniert das Scannen',
                    text: '1. Benefit-Karte antippen\n2. "QR-Code scannen" Button drücken\n3. Kamera erlauben (beim ersten Mal)\n4. QR-Code des Partners scannen\n5. Fertig! Einlösung wird gespeichert\n\nDie Kamera schließt automatisch nach erfolgreichem Scan.'
                },
                {
                    title: '📊 Statistiken (Admin)',
                    text: 'Admins sehen:\n• Wer hat welchen Benefit eingelöst?\n• Wann wurde eingelöst?\n• Wie oft wurde jeder Benefit genutzt?\n• Verbleibende Einlösungen pro Mitarbeiter'
                },
                {
                    title: '🖨️ QR-Code herunterladen (Admin)',
                    text: 'Im Benefit-Bearbeitungsmenü:\n1. Benefit mit QR-Scan öffnen\n2. "QR-Code herunterladen" klicken\n3. PNG-Datei wird generiert\n4. Datei ausdrucken und beim Partner aufstellen'
                },
                {
                    title: '⚙️ Benefits verwalten (Admin)',
                    text: '• Hover über eine Karte → Edit/Delete-Buttons unten rechts\n• Oder im VIP-Modal → "Bearbeiten"-Button\n• Felder: Name, Rabatt, Beschreibung, Logo, Kategorie, Standort, Gültigkeit\n• "Nur während Arbeitszeit einlösbar" Checkbox\n• "QR-Scan erforderlich" Toggle\n• "Max. Einlösungen pro Person" Eingabefeld\n• "Einlöse-Hinweis" Textfeld (z.B. Kontaktname, was vorzeigen)'
                }
            ]
        },
        {
            id: 'team',
            icon: Users,
            title: 'Team Hub',
            color: '#00B4D8',
            content: [
                {
                    title: '👥 Team-Übersicht',
                    text: 'Alle Teammitglieder auf einen Blick mit Profilbild, Name, Rolle und Online-Status.'
                },
                {
                    title: '🔍 Profil-Details',
                    text: 'Klick auf ein Teammitglied → Skills, Kontaktinfo, aktuelle Tasks, Standort, Bio.'
                },
                {
                    title: '⚡ Schnellaktionen',
                    text: 'Direkt aus dem Profil: Chat starten, Anrufen, Task zuweisen.'
                },
                {
                    title: '🏷️ Anzeige-Position',
                    text: 'Admin kann jedem User eine individuelle Position vergeben (z.B. "Motion-Designer"), die überall statt der Systemrolle angezeigt wird.'
                },
                {
                    title: '🟢 Auto-Away Status',
                    text: 'Online-Status wird automatisch verwaltet:\n• Nach 30 Min Inaktivität → "Abwesend" (gelb)\n• Bei Aktivität (Klick, Scrollen, Tippen) → "Online" (grün)\n\nManuell gesetzte Status wie "Beschäftigt" oder "Nicht stören" bleiben erhalten.'
                }
            ]
        },
        {
            id: 'social-faces',
            icon: Users,
            title: 'Social Faces',
            color: '#EC4899',
            content: [
                {
                    title: '🎭 Was ist Social Faces?',
                    text: 'Die Talentdatenbank für Content-Produktionen. Hier verwaltest du Statisten, Models und Influencer für Shootings.\n\n• Bewerbungsformular für neue Talente\n• Filterfunktionen nach Aussehen, Fähigkeiten, Standort\n• Punktesystem für Zuverlässigkeit\n• Shooting-Zusagen verwalten'
                },
                {
                    title: '📝 Bewerbungsformular',
                    text: 'Öffentlicher Link für neue Talente:\n→ /social-faces\n\nErfasst: Name, Kontakt, Fotos, Größe, Haarfarbe, Ernährung, Deutschkenntnisse, Social Media Profile, Tattoos/Piercings/Brille'
                },
                {
                    title: '🔍 Datenbank durchsuchen',
                    text: 'Filter nach:\n• Land (DE/AT)\n• Geschlecht\n• Haarfarbe\n• Ernährung (Vegan, Vegetarisch, etc.)\n• Deutschkenntnisse\n• Tattoos, Piercings, Brille\n\nKombiniere mehrere Filter für gezielte Suche.'
                },
                {
                    title: '🤖 KI-Suche (Tipp!)',
                    text: 'Nutze den KI-Assistenten für schnelle Suchen:\n• "Zeig mir blonde Frauen aus Wien"\n• "Vegetarische Models ohne Tattoos"\n• "Männer mit braunen Haaren und Piercing"\n\nErgebnisse werden direkt im Chat angezeigt!'
                },
                {
                    title: '⚠️ Punktesystem',
                    text: 'Bei Unzuverlässigkeit:\n1. Punkt = Verwarnung\n2. Punkte = Letzte Warnung\n3. Punkte = Automatische Blacklist\n\nPunkte können mit Begründung vergeben werden. Historie wird gespeichert.'
                },
                {
                    title: '📋 Shooting-Zusagen',
                    text: 'Talente bestätigen Shooting-Teilnahme:\n→ /shooting-zusage\n\nFormular erfasst: Name, Kunde, Shooting-Datum, Unterschrift\n\nAdmin kann Zusagen als PDF exportieren.'
                },
                {
                    title: '⚙️ Einstellungen (Admin)',
                    text: '• WhatsApp Gruppen-Link: Bewerber werden nach dem Absenden weitergeleitet\n• Einverständniserklärung PDF: Hochladen für automatische Zusendung'
                }
            ]
        },
        {
            id: 'content-library',
            icon: Globe,
            title: 'Content Bibliothek',
            color: '#6366F1',
            content: [
                {
                    title: '📚 Was ist das?',
                    text: 'Zentrale Sammlung von Content-Ideen für Social Media. Gefiltert nach Branche, Format und Feiertagen.'
                },
                {
                    title: '➕ Content erstellen',
                    text: 'Titel, Beschreibung, Link (optional)\n\nAttribute:\n• Video / Bild / Grafik\n• Lustig / Informativ\n• Mit Reden / Ohne Reden\n• Branche (z.B. Gastronomie, Mode)\n• Feiertag zuordnen'
                },
                {
                    title: '🔍 Filter',
                    text: 'Nach Format, Kategorie und Feiertag filtern. Suchfunktion für schnelles Finden.'
                },
                {
                    title: '📅 Content Kalender',
                    text: 'Tab "Content Kalender" zeigt alle Feiertage:\n• Opernball, Valentinstag, Ostern\n• Star Wars Day, Muttertag, Pride\n• Halloween, Black Friday, Weihnachten\n\nKlick auf Feiertag → Filter nach zugehörigen Content-Ideen.'
                },
                {
                    title: '⚙️ Branchen verwalten',
                    text: 'Zahnrad-Icon (nur Admin) → Neue Branchen hinzufügen/löschen.'
                },
                {
                    title: '📋 Berechtigungen',
                    text: 'Jeder kann Content erstellen und eigene bearbeiten.\nNur Admin kann fremde Einträge löschen.'
                }
            ]
        },
        {
            id: 'influencers',
            icon: Users,
            title: 'Influencer',
            color: '#E91E63',
            content: [
                {
                    title: '📸 Was ist das?',
                    text: 'Datenbank aller Influencer für Kooperationen. 134+ Influencer bereits vorinstalliert!'
                },
                {
                    title: '📋 Datenfelder',
                    text: '• Name / Instagram-Handle\n• Follower-Anzahl\n• Kategorien (Food, Lifestyle, Mode, Sport...)\n• Standort (Wien, Graz, Innsbruck...)\n• Kollaborations-Details (Preise)'
                },
                {
                    title: '🔍 Filter & Suche',
                    text: 'Filter nach Kategorie und Standort.\nSortierung nach Followern (auf-/absteigend) oder Name.'
                },
                {
                    title: '📋 Kopieren',
                    text: 'Copy-Button kopiert den Instagram-Link direkt in die Zwischenablage.'
                },
                {
                    title: '⚙️ Verwalten (Admin)',
                    text: 'Nur Admin kann Influencer hinzufügen, bearbeiten oder löschen.'
                }
            ]
        },
        {
            id: 'communications',
            icon: MessageCircle,
            title: 'Kommunikation',
            color: '#10B981',
            content: [
                {
                    title: '💬 Was ist das?',
                    text: 'Vorlagen für WhatsApp-Nachrichten zum schnellen Kopieren und Versenden.'
                },
                {
                    title: '📝 Vorlagen-Struktur',
                    text: '• Titel/Name der Vorlage\n• Nachrichtentext (mit Platzhaltern wie [Name])\n• Kategorie (z.B. Begrüßung, Follow-Up, Angebot)'
                },
                {
                    title: '📋 Kopieren',
                    text: 'Klick auf "Kopieren" → Nachricht in Zwischenablage → In WhatsApp einfügen.'
                },
                {
                    title: '🔍 Filter',
                    text: 'Nach Kategorie filtern oder per Suche finden.'
                },
                {
                    title: '⚙️ Kategorien verwalten',
                    text: 'Zahnrad-Icon (nur Admin) → Kategorien hinzufügen/löschen.'
                },
                {
                    title: '📋 Berechtigungen',
                    text: 'Jeder kann Vorlagen sehen und kopieren.\nNur Admin kann Vorlagen erstellen/bearbeiten/löschen.'
                }
            ]
        },
        {
            id: 'tools',
            icon: Key,
            title: 'Tools & Passwörter',
            color: '#8E8E93',
            content: [
                {
                    title: '🔧 Team-Tools',
                    text: 'Gemeinsam genutzte Tool-Zugänge. Name, Website-URL, Benutzername, E-Mail, Passwort, Beschreibung.'
                },
                {
                    title: '🔐 Persönliche Passwörter',
                    text: 'Private Passwort-Verwaltung. Nur für eigenen Account sichtbar. Mit Passwort-Generator.'
                }
            ]
        },
        {
            id: 'notes',
            icon: StickyNote,
            title: 'Notizen',
            color: '#FFCC00',
            content: [
                {
                    title: '📝 Notiz erstellen',
                    text: 'Titel und Inhalt (Markdown unterstützt). Gelbe Sticky-Note-Optik.'
                },
                {
                    title: '📂 Organisation',
                    text: 'Automatisch nach Aktualisierung sortiert. Neueste zuerst.'
                }
            ]
        },
        {
            id: 'admin',
            icon: Shield,
            title: 'Admin-Bereich',
            color: '#FF453A',
            content: [
                {
                    title: '👤 Benutzer verwalten',
                    text: 'Neuer Benutzer: E-Mail, Benutzername, Passwort, Vorname, Nachname, Rolle, Anzeige-Position, Wochenstunden, Urlaubstage, Profilfarbe.'
                },
                {
                    title: '📋 Task-Status verwalten',
                    text: 'Status hinzufügen, Emoji und Farbe wählen, Reihenfolge per Drag & Drop.'
                },
                {
                    title: '⚙️ Module aktivieren/deaktivieren',
                    text: 'Im Design-Tab:\n• Challenges: Team-Challenges & Achievements\n• Team-Chat: Interner Chat\n• Projekte: Projekt-Verwaltung\n\nDeaktivierte Module verschwinden aus dem Menü für alle Benutzer.'
                },
                {
                    title: '⚙️ System-Einstellungen',
                    text: 'Firmenname, Logo, Primärfarbe, Sekundärfarbe, Akzentfarbe, Standard-Theme, Aktivitätstypen, App-URL (für E-Mail-Links).'
                },
                {
                    title: '📜 Audit-Log',
                    text: 'Protokollierte Aktionen: Login, Benutzer erstellen/bearbeiten/löschen, Kunden, Tasks, Zeiterfassung. Mit Filter und Suche.'
                },
                {
                    title: '📊 Statistiken',
                    text: 'Übersicht: Aktive/Gesamte Mitarbeiter & Kunden, Projekte, Tasks, Urlaubstage.'
                },
                {
                    title: '📧 E-Mail-System',
                    text: 'Automatische E-Mails:\n• Willkommensmails mit Zugangsdaten\n• Wöchentliche Zeitreports (Freitags)\n• Monatliche Zeitübersicht (letzter Tag des Monats)\n• Task-Erinnerungen bei Deadline\n• Urlaubsanträge & Genehmigungen'
                },
                {
                    title: '📖 API-Dokumentation',
                    text: 'Swagger UI unter /api/docs verfügbar. Vollständige API-Referenz mit allen Endpunkten.'
                }
            ]
        },
        {
            id: 'public',
            icon: Globe,
            title: 'Öffentliche Kunden-Portale',
            color: '#32ADE6',
            content: [
                {
                    title: '🌐 Aktivierung',
                    text: 'Kunde → Globe-Icon → Public Page Einstellungen → Seite aktivieren.'
                },
                {
                    title: '🔒 Sicherheits-Optionen',
                    text: '• Passwortschutz: Optionales Passwort für Zugang\n• Ablaufdatum: Link wird nach Datum automatisch deaktiviert\n• QR-Code: Generieren und als PNG herunterladen'
                },
                {
                    title: '🎨 Corporate Identity Tab',
                    text: '• Farbpalette: Alle CI-Farben mit HEX-Codes zum Kopieren\n• Logos: Alle Kundenlogos zum Download\n• Vorschau der Farben in verschiedenen Anwendungen'
                },
                {
                    title: '🔗 Links Tab',
                    text: '• Benutzerdefinierte Links für den Kunden\n• Jeder Link: Emoji, Name, URL, Beschreibung\n• Links aktivieren/deaktivieren\n• Drag & Drop zum Sortieren'
                },
                {
                    title: '📅 Content-Plan Tab',
                    text: '• Monatskalender mit allen geplanten Social Media Posts\n• Posts nach Plattform: Instagram, Facebook, LinkedIn, TikTok, etc.\n• Jeder Post zeigt: Datum, Plattform, Beschreibung, Bild/Video\n• Status-System: Entwurf → Zur Freigabe → Freigegeben → Veröffentlicht\n• Kunde kann Posts direkt freigeben mit einem Klick\n• Bei Änderungswünschen: Feedback-Feld für Kommentare\n• Filterbar nach Monat, Plattform und Status\n• Agentur erhält Benachrichtigung bei Feedback'
                },
                {
                    title: '📊 Reports Tab',
                    text: '• Monatliche Performance-Berichte für den Kunden\n• KPI-Cards: Reichweite, Impressionen, Engagement, Follower-Wachstum\n• Interaktive Charts: Linien-Diagramme für Trends, Balken für Vergleiche\n• Plattform-Breakdown: Statistiken pro Social Media Kanal\n• Top-Posts: Die erfolgreichsten Beiträge des Monats\n• PDF-Export: Berichte als PDF herunterladen\n• Vergleich zum Vormonat mit Prozent-Änderungen\n• Automatisch generierte Insights und Empfehlungen'
                }
            ]
        },
        {
            id: 'public-links',
            icon: Globe,
            title: 'Öffentliche Links',
            color: '#10B981',
            content: [
                {
                    title: '🔗 Verfügbare öffentliche Seiten',
                    text: 'AgencyOS bietet 3 öffentliche Seiten, die ohne Login erreichbar sind:\n\n1. Social Faces Bewerbung\n2. Shooting-Zusage\n3. Kunden-Portal'
                },
                {
                    title: '📝 /social-faces',
                    text: 'Öffentliches Bewerbungsformular für neue Talente.\n\nTeile diesen Link mit potenziellen Models/Statisten:\n→ Vollständiges Formular mit Foto-Upload\n→ Erfasst alle relevanten Daten\n→ Nach dem Absenden: Weiterleitung zur WhatsApp-Gruppe\n→ Daten erscheinen sofort in der Admin-Datenbank'
                },
                {
                    title: '✅ /shooting-zusage',
                    text: 'Formular für Shooting-Bestätigungen.\n\nTalente bestätigen ihre Teilnahme:\n→ Name, Kunde, Datum eingeben\n→ Digitale Unterschrift per Touch/Maus\n→ Rechtlich verbindliche Zusage\n→ Admin kann als PDF exportieren'
                },
                {
                    title: '🌐 /p/{slug}',
                    text: 'Individuelles Kunden-Portal.\n\nJeder Kunde kann sein eigenes Portal bekommen:\n→ CI-Farben und Logos\n→ Wichtige Links\n→ Content-Plan mit Freigabe-Workflow\n→ Performance-Reports\n\nAktivierung: Kunden-Detail → Globe-Icon'
                }
            ]
        },
        {
            id: 'settings',
            icon: Settings,
            title: 'Einstellungen',
            color: '#8E8E93',
            content: [
                {
                    title: '👤 Profil',
                    text: 'Vorname, Nachname, E-Mail, Geburtstag, Profilbild, Profilfarbe, Wetter-Standort, Bio, Skills.'
                },
                {
                    title: '🎨 Theme',
                    text: 'Hell (Light Mode), Dunkel (Dark Mode), System (automatisch).'
                },
                {
                    title: '🔗 Meine Links',
                    text: 'Eigene Links in der Sidebar hinzufügen. Titel, URL, Icon (Emoji).'
                },
                {
                    title: '📅 Kalender-Verbindung',
                    text: 'Google Calendar oder iCloud verbinden für Synchronisation.'
                },
                {
                    title: '🔔 Benachrichtigungen',
                    text: 'E-Mail-Benachrichtigungen pro Typ ein/ausschalten: Task-Zuweisung, Urlaub, Erinnerungen, Wochenberichte.'
                },
                {
                    title: '🔑 Google-Login',
                    text: 'Optionale zweite Gmail-Adresse für Google-Anmeldung hinterlegen.'
                }
            ]
        }
    ];

    const filteredChapters = chapters.filter(chapter => {
        if (!searchQuery) return true;
        const query = searchQuery.toLowerCase();
        return chapter.title.toLowerCase().includes(query) ||
            chapter.content.some(c => c.title.toLowerCase().includes(query) || c.text.toLowerCase().includes(query));
    });

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-950">
            {/* Header */}
            <div className="sticky top-0 z-50 bg-white/80 dark:bg-gray-900/80 backdrop-blur-xl border-b border-gray-200/50 dark:border-gray-800/50">
                <div className="max-w-5xl mx-auto px-4 py-2">
                    <div className="flex items-center gap-4">
                        <img 
                            src={logoUrl} 
                            alt="nyza Logo" 
                            className="w-32 h-16 object-contain dark:invert-0 invert flex-shrink-0"
                            onError={(e) => {
                                e.target.style.display = 'none';
                            }}
                        />
                        <div className="flex-shrink-0">
                            <h1 className="text-lg font-bold text-gray-900 dark:text-white">AgencyOS Handbuch</h1>
                            <p className="text-xs text-gray-500 dark:text-gray-400">Feature-Dokumentation</p>
                        </div>
                        
                        {/* Search */}
                        <div className="flex-1 relative ml-4">
                            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                            <Input
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                placeholder="Suche..."
                                className="pl-9 h-9 rounded-xl bg-gray-100 dark:bg-gray-800 border-0 text-sm w-full"
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Content */}
            <div className="max-w-5xl mx-auto px-4 py-8">
                <Tabs defaultValue="all" className="w-full">
                    <TabsList className="mb-8 bg-white/50 dark:bg-gray-800/50 backdrop-blur-sm rounded-xl p-1.5 flex-wrap h-auto gap-2">
                        <TabsTrigger value="all" className="rounded-lg px-4 py-2 data-[state=active]:bg-white dark:data-[state=active]:bg-gray-700">
                            Alle
                        </TabsTrigger>
                        <TabsTrigger value="basics" className="rounded-lg px-4 py-2 data-[state=active]:bg-white dark:data-[state=active]:bg-gray-700">
                            Grundlagen
                        </TabsTrigger>
                        <TabsTrigger value="productivity" className="rounded-lg px-4 py-2 data-[state=active]:bg-white dark:data-[state=active]:bg-gray-700">
                            Produktivität
                        </TabsTrigger>
                        <TabsTrigger value="team" className="rounded-lg px-4 py-2 data-[state=active]:bg-white dark:data-[state=active]:bg-gray-700">
                            Team
                        </TabsTrigger>
                        <TabsTrigger value="admin" className="rounded-lg px-4 py-2 data-[state=active]:bg-white dark:data-[state=active]:bg-gray-700">
                            Admin
                        </TabsTrigger>
                    </TabsList>

                    <TabsContent value="all">
                        <div className="space-y-5">
                            {filteredChapters.map((chapter, index) => (
                                <ChapterCard 
                                    key={chapter.id} 
                                    chapter={chapter} 
                                    index={index}
                                    expanded={expandedSections[chapter.id]}
                                    onToggle={() => toggleSection(chapter.id)}
                                />
                            ))}
                        </div>
                    </TabsContent>

                    <TabsContent value="basics">
                        <div className="space-y-5">
                            {filteredChapters.filter(c => ['login', 'dashboard', 'settings'].includes(c.id)).map((chapter, index) => (
                                <ChapterCard 
                                    key={chapter.id} 
                                    chapter={chapter} 
                                    index={index}
                                    expanded={expandedSections[chapter.id]}
                                    onToggle={() => toggleSection(chapter.id)}
                                />
                            ))}
                        </div>
                    </TabsContent>

                    <TabsContent value="productivity">
                        <div className="space-y-5">
                            {filteredChapters.filter(c => ['ai-assistant', 'tasks', 'time', 'projects', 'calendar', 'notes', 'forms'].includes(c.id)).map((chapter, index) => (
                                <ChapterCard 
                                    key={chapter.id} 
                                    chapter={chapter} 
                                    index={index}
                                    expanded={expandedSections[chapter.id]}
                                    onToggle={() => toggleSection(chapter.id)}
                                />
                            ))}
                        </div>
                    </TabsContent>

                    <TabsContent value="team">
                        <div className="space-y-5">
                            {filteredChapters.filter(c => ['customers', 'chat', 'vacation', 'challenges', 'benefits', 'social-faces'].includes(c.id)).map((chapter, index) => (
                                <ChapterCard 
                                    key={chapter.id} 
                                    chapter={chapter} 
                                    index={index}
                                    expanded={expandedSections[chapter.id]}
                                    onToggle={() => toggleSection(chapter.id)}
                                />
                            ))}
                        </div>
                    </TabsContent>

                    <TabsContent value="admin">
                        <div className="space-y-5">
                            {filteredChapters.filter(c => ['admin', 'public', 'public-links', 'tools'].includes(c.id)).map((chapter, index) => (
                                <ChapterCard 
                                    key={chapter.id} 
                                    chapter={chapter} 
                                    index={index}
                                    expanded={expandedSections[chapter.id]}
                                    onToggle={() => toggleSection(chapter.id)}
                                />
                            ))}
                        </div>
                    </TabsContent>
                </Tabs>

                {/* Footer */}
                <div className="mt-12 text-center text-sm text-gray-500 dark:text-gray-400 pb-8">
                    <p>Copyright © 2026 TGOSM | Made with ♥ in Vienna</p>
                </div>
            </div>
        </div>
    );
};

const ChapterCard = ({ chapter, index, expanded, onToggle }) => {
    const Icon = chapter.icon;
    
    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.05 }}
        >
            <Card className="overflow-hidden border-0 shadow-lg hover:shadow-xl transition-all duration-300 bg-white dark:bg-gray-900">
                <button
                    onClick={onToggle}
                    className="w-full p-4 flex items-center justify-between hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors"
                >
                    <div className="flex items-center gap-4">
                        <div 
                            className="w-12 h-12 rounded-2xl flex items-center justify-center shadow-lg"
                            style={{ backgroundColor: `${chapter.color}20` }}
                        >
                            <Icon className="w-6 h-6" style={{ color: chapter.color }} />
                        </div>
                        <div className="text-left">
                            <h3 className="font-semibold text-lg text-gray-900 dark:text-white">{chapter.title}</h3>
                            <p className="text-sm text-gray-500 dark:text-gray-400">{chapter.content.length} Themen</p>
                        </div>
                    </div>
                    <motion.div
                        animate={{ rotate: expanded ? 90 : 0 }}
                        transition={{ duration: 0.2 }}
                    >
                        <ChevronRight className="w-5 h-5 text-gray-400" />
                    </motion.div>
                </button>

                <AnimatePresence>
                    {expanded && (
                        <motion.div
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: 'auto', opacity: 1 }}
                            exit={{ height: 0, opacity: 0 }}
                            transition={{ duration: 0.3 }}
                        >
                            <CardContent className="pt-0 pb-4">
                                <div className="border-t border-gray-100 dark:border-gray-800 pt-4 space-y-4">
                                    {chapter.content.map((item, idx) => (
                                        <motion.div
                                            key={idx}
                                            initial={{ opacity: 0, x: -10 }}
                                            animate={{ opacity: 1, x: 0 }}
                                            transition={{ delay: idx * 0.05 }}
                                            className="p-4 rounded-xl bg-gray-50 dark:bg-gray-800/50"
                                        >
                                            <h4 className="font-medium text-gray-900 dark:text-white mb-2">{item.title}</h4>
                                            <p className="text-sm text-gray-600 dark:text-gray-400 whitespace-pre-line">{item.text}</p>
                                        </motion.div>
                                    ))}
                                </div>
                            </CardContent>
                        </motion.div>
                    )}
                </AnimatePresence>
            </Card>
        </motion.div>
    );
};

export default HandbuchPage;
